module.exports = __webpack_public_path__ + "static/media/italics.27b30041.svg";